
export enum RoutingOptionType {
  NEXT_STATION = 'NEXT_STATION', //
  RESTART_ROUTE = 'RESTART_ROUTE', //
  SELECT_STATION = 'SELECT_STATION', //
  FORWARD_TO_PROCESS = 'FORWARD_TO_PROCESS', //
  FINISH_ROUTE = 'FINISH_ROUTE', //
  WAITING_FOR_RETRIEVE = 'WAITING_FOR_RETRIEVE', //
  WAITING_FOR_PULLING = 'WAITING_FOR_PULLING', //
  PLAN_ASSIGNMENT = 'PLAN_ASSIGNMENT' //
}

export class TransportCompletionOption {

  targetStationId: number;
  sourceStationId: number;
  routingOptionType: RoutingOptionType;

}

export class CompleteTransportAssignment {

  routingOptionType: RoutingOptionType;
  sourceStationId: number;
  transportId: number;
  targetStationId: number;

}
